// extracted by mini-css-extract-plugin
export var emptyState = "_6q-d";
export var statCard = "_6q-c";
export var table = "_6q-0";
export var tableCell = "_6q-4";
export var tableCellClickable = "_6q-5 _6q-4";
export var tableCellDefault = "_6q-6 _6q-4";
export var tableCellEmpty = "_6q-8";
export var tableCellWithValue = "_6q-7";
export var tableContainer = "_6q-e";
export var tableHeaderWeight = "_6q-1";
export var tableHeaderZone = "_6q-2";
export var tableRowHeader = "_6q-3";
export var viewModeButton = "_6q-9";
export var viewModeButtonActive = "_6q-a _6q-9";
export var viewModeButtonInactive = "_6q-b _6q-9";